import { inAppEscapeUrl, inAppMenuSay } from "@greg-chick/shared";
import { platformOs, type PlatformInfo } from "../lib/platform";

/**
 * 🚪 **인앱 브라우저에서 나가는 단추** — 카카오톡이면 지금 주소를 기본 브라우저로 연다(2026-10-08).
 *
 * 그런 길이 없는 앱(인스타 등)·보통 브라우저면 아무것도 안 그린다 — 없는 단추를 만들지 않는다.
 * 주소 규칙은 shared `inAppEscapeUrl` 한 곳. AR(목록·카드)과 화상 무대(수업·행사·화상 주소 칸)가 같은 단추를 쓴다.
 */
export function InAppEscapeLink({ platform, className = "btn btn--primary ar__escape" }: { platform: PlatformInfo; className?: string }) {
  if (!platform.isInApp) return null;
  const escapeUrl = inAppEscapeUrl(platform.inAppName, window.location.href);
  if (!escapeUrl) return null;
  return (
    <a className={className} href={escapeUrl}>
      🌐 기본 브라우저로 열기
    </a>
  );
}

/**
 * 🚪 **인앱 브라우저 안내 + 나가는 단추** — AR 목록과 AR 카드가 같은 조각을 쓴다.
 *
 * 두 화면이 각자 문구를 들고 있었고, 그중 하나는 아이폰에 없는 자리(「우측 상단」)를 말했다.
 * 말(`inAppMenuSay`)과 단추 주소(`inAppEscapeUrl`)는 shared 한 곳. 보통 브라우저면 아무것도 안 그린다(겁주지 않는다).
 *
 * @param lead 앞머리 한 줄(화면마다 다르다 — 목록은 「제한될 수 있어요」, 카드는 「더 잘 동작해요」)
 */
export function InAppEscapeNote({
  platform,
  lead,
  className = "ar__warn",
}: {
  platform: PlatformInfo;
  lead: React.ReactNode;
  className?: string;
}) {
  if (!platform.isInApp) return null;
  return (
    <div className={className}>
      <p>
        {lead} {inAppMenuSay(platformOs(platform))}.
      </p>
      <InAppEscapeLink platform={platform} />
    </div>
  );
}
